import FunctionalButton from "./FunctionalButton";

const CancelButton = ({
    className,
    ...otherProps
}: React.ComponentProps<typeof FunctionalButton>) => (
    <FunctionalButton
        {...otherProps}
        className={`button bg-black60 hover:bg-black40 disabled:bg-black80 ${className}`}
    ></FunctionalButton>
);

export default CancelButton;
